<template>
  <form @submit.prevent="save">
    <div class="nk-block">
      <div class="nk-block-head">
        <h5 class="title">Otros documentos</h5>
        <p></p>
      </div><!-- .nk-block-head -->
      <div v-if="!otros.length" class="alert alert-info">
        <p>Aún no se ha añadido ningún registro, da clic en <b>Agregar Documento</b> para añadir uno.</p>
      </div>
      <div v-for="otro in otros" :key="otro.id_otro" class="row">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <button type="button" class="btn btn-outline-danger" @click.prevent="remove(otro)">Eliminar registro</button>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Nombre</label>
            <input type="text" class="form-control" v-model.lazy="otro.nombre">
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Fecha</label>
            <input type="date" class="form-control" v-model.lazy="otro.fecha">
          </div>
        </div>
        <div class="col-sm-6 mt-3">
          <div class="form-group">
            <label class="form-label">Comprobante</label>
            <Uploader :preFiles="$filters.getFiles(otro.f_certificado?.id_archivo)" :server="$filters.getServer(model)" v-model:file="otro.f_certificado"></Uploader>
          </div>
        </div>
      </div>
      <div class="w-100 text-right">
        <button type="button" class="mt-2 btn btn-lg btn-info" @click.prevent="add">Agregar Documento</button>
      </div>
    </div><!-- .nk-block -->
  </form>
</template>

<script>
import {useApi} from "@/use/useApi";
import {reactive, toRefs, defineComponent, computed, watch} from 'vue';
import { useRouter } from 'vue-router';
import Swal from "sweetalert2";
import Uploader from "@/components/globales/Uploader";
const { v4: uuidv4 } = require('uuid');

export default defineComponent({
  name: "OtrosEmpleado",
  props: ['empleado'],
  components: {
    Uploader
  },
  setup(params) {
    //Data
    const { loading, make } = useApi();
    const router = useRouter();

    const model = computed(()=>{
      return params.empleado;
    });

    const state = reactive({
      otros: [],
      inited: false
    });

    //Methods
    async function get(){
      loading.message = 'Obteniendo información';
      let {data} = await make('empleados/otros/get', {id_empleado: model.value.id_empleado});
      if(data === null){
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
        router.go();
      } else {
        if(data.error){
          await Swal.fire('Error', data.message, 'error');
        } else {
          state.otros = data.otros;
        }
      }
    }

    async function save(){
      loading.message = 'Actualizando información';
      //Save
      let {data} = await make('empleados/otros/edit', {model: state.otros, id_empleado: model.value.id_empleado});
      if(data === null){
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
      } else {
        if(data.error){
          await Swal.fire('Error', data.message, 'error');
        }
      }
    }

    function add() {
      state.otros.push({
        id_otro: uuidv4(),
        nombre: '',
        fecha: null,
        f_certificado: {
          id_archivo: false,
          estatus: 'Pendiente',
          url: '#',
          autorizo: '',
          subio: '',
          nombre: ''
        }
      });
    }

    function remove(otro){
      state.otros = state.otros.filter(_otro => _otro.id_otro !== otro.id_otro);
    }

    watch(() => state.otros, () => {
      if(state.inited){
        save();
      } else {
        state.inited = true;
      }
    }, {deep: true});

    get();

    return {model, ...toRefs(state), loading, save, get, add, remove};
  }
});
</script>

<style scoped>
  textarea.form-control {
    min-height: 75px;
  }
  .form-label {
    text-transform: uppercase;
  }
</style>